import "./promise-allsettled-polyfill";
import "./styles/globals.css";
import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";
// import { FluentProvider, webLightTheme } from "@fluentui/react-components";

/* global document, Office, module, require, HTMLElement */

const title = "WorkOps Add-in";

const rootElement: HTMLElement | null = document.getElementById("container");
const root = rootElement ? createRoot(rootElement) : undefined;

/* Render application after Office initializes */
Office.onReady(() => {
  root?.render(
    <App title={title} />
  );
  
  // Hide initial loader after React mounts
  setTimeout(() => {
    const loader = document.getElementById("initial-loader");
    const container = document.getElementById("container");
    if (loader) loader.style.display = "none";
    if (container) container.style.display = "block";
  }, 100);
});

if ((module as any).hot) {
  (module as any).hot.accept("./components/App", () => {
    const NextApp = require("./components/App").default;
    root?.render(NextApp);
  });
}
